export const csvEscape = (str) => {
  if (/"/g.test(str)) str = str.replaceAll(/"/g, '""');
  str = /[,"\s]/g.test(str) ? `"${str}"` : str;
  return str;
};

export const downloadCsv = (contents: string, filename: string) => {
  const blob = new Blob([contents], { type: "text/csv;charset=utf8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.documentElement.appendChild(a);
  a.click();
  setTimeout(() => {
    document.documentElement.removeChild(a);
    window.URL.revokeObjectURL(url);
  }, 0);
};
